import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { JobDetailPage } from '@/features/jobs/components/job-detail-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/jobs/$jobId',
)({
  validateSearch: z.object({ launch: z.boolean().optional() }),
  component: JobDetailPage,
  beforeLoad: () => ({
    title: 'Job',
    headerTitleKey: 'header.jobs.title',
    headerDescriptionKey: 'header.jobs.description',
  }),
})
